import React from "react";
import {Box, Button, ButtonGroup, FormControlLabel, Switch} from "@mui/material";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import './KoiKeyDataFacts.scss';
import {toCurrency} from "../../../components/currency-component/CurrencyClasses";
import type {Bag} from "../../../services/classes/Bag";
import type {
    FilterSpecification
} from "../../../components/visualization/collapsible-indent-tree/CollapsibleIndentTree";
import {UNCATEGORIZED_LABEL} from "../../../constants";
import {DownloadReviewButtons} from "./DownloadReviewButtons";
import type {Subject} from "rxjs";

type Props = {
    $filter: FilterSpecification
    filter: number
    setFilter: (filter: number) => void
    hiddenUncat: boolean
    setHiddenUncat: (hiddenUncat: boolean) => void
}
export const KoiKeyDataFactsToolbar: React.FC<Props> = observer((
    {$filter, filter, setFilter, hiddenUncat, setHiddenUncat}) => {
    const {bagStore, p} = useStores();
    const bag = bagStore.bag as Bag;

    return <Box className="koi-kdf-toolbar">
        <DownloadReviewButtons/>
        <ButtonGroup>
            {[...Array(bag.taxonomy_size)].map((_, i) =>
                <Button
                    key={i}
                    color="primary"
                    onClick={() => {
                        // bugfix when pressing L3->L1->L2
                        ($filter.byLevel as Subject<number>).next(i);
                        ($filter.byLevel as Subject<number>).next(i);
                    }}
                    variant="outlined">
                    L{String(i + 1)}
                </Button>
            )}
        </ButtonGroup>
        <ButtonGroup className="biggest-group">
            <Button onClick={() => setFilter(0)} variant={filter === 0 ? 'contained' : 'outlined'}
                    color="primary">
                No filter
            </Button>
            <Button onClick={() => setFilter(1)} variant={filter === 1 ? 'contained' : 'outlined'}
                    color="primary">
                &ge;&nbsp;{toCurrency(p.currencySymbol, 1_000, 3, undefined, undefined, true)}
            </Button>
            <Button onClick={() => setFilter(2)} variant={filter === 2 ? 'contained' : 'outlined'}
                    color="primary">
                &ge;&nbsp;{toCurrency(p.currencySymbol, 1_000_000, 3, undefined, undefined, true)}
            </Button>
            <Button onClick={() => setFilter(3)} variant={filter === 3 ? 'contained' : 'outlined'}
                    color="primary">
                &ge;&nbsp;5&nbsp;{p.supplierDataName}s
            </Button>
            <Button onClick={() => setFilter(4)} variant={filter === 4 ? 'contained' : 'outlined'}
                    color="primary">
                &ge;&nbsp;100&nbsp;{p.partDataName || 'transactions'}
            </Button>
        </ButtonGroup>
        {/*<Button onClick={() => setHiddenRoot(!hiddenRoot)} variant="outlined"*/}
        {/*        color="primary">*/}
        {/*    {hiddenRoot ? 'Show total' : 'Hide total'}*/}
        {/*</Button>*/}

        <FormControlLabel
            sx={{mx: 0}}
            control={<Switch size="small"
                             checked={!hiddenUncat}
                             onChange={() => setHiddenUncat(!hiddenUncat)}/>}
            label={UNCATEGORIZED_LABEL}
        />
    </Box>;
});
